import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"

const AdvertisingFees = () => {
  const data = [
    { label: "Sponsored Products", value: "$0.50 per click" },
    { label: "Sponsored Brands", value: "$1.00 per click" },
    { label: "Display Ads", value: "$2.00 per 1,000 impressions" },
  ]

  const columns = [
    { name: 'Ad Types', selector: row => row.label },
    { name: 'Cost', selector: row => row.value },
  ]

  return (
    <div>
      <div className="fw-semibold fs-5">Advertising Fees</div>

      <div className="px-5 py-2">
        <DatatableComponent data={data} columns={columns} type='yellow' />
      </div>
    </div>
  )
}

export default AdvertisingFees
